import InApp from 'detect-inapp';
import {showToastSuccess} from "../../v2/common/function";
// for add 3 dots in string
export const add3Dots = (source, size, showFullTitle) => {
    if (showFullTitle) {
        return source; // Return the full title without truncating
    }
    return (source && source.length > size) ? source.slice(0, size - 1) + "…" : source;
}

// Hex to RGB
export const hexToRgba = (hex, alpha) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    const bg_color = result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
    if (bg_color) return `rgba(${bg_color.r}, ${bg_color.g}, ${bg_color.b}, ${alpha ? alpha : 1})`;
    return ''
}

export const findArray = (arrList = [], id) => {
    if (arrList && arrList.length) return arrList.find(_ => _.value === id)
}

export const isMobileDevice = () => {
    return ('ontouchstart' in document.documentElement);
}

export const errorFocus = (flag) => {
    setTimeout(() => {
        const elem = document.getElementsByClassName('u_input-error')
        if (elem && elem[0]) {

            if (flag === 'top') elem[0].scrollIntoView({behavior: "smooth"});
            else elem[0].scrollIntoView({behavior: "smooth", block: "nearest", inline: 'nearest'});
        }
    }, 200)
}

export const dataURLtoFile = (dataUrl, filename, mime = "image/jpg") => {
    let arr = dataUrl.split(','),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type: mime});
}

export const copyToClipboard = (url, message) => {
    const el = document.createElement('textarea');
    el.value = url;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    showToastSuccess(message || 'Link copied successfully');
}
export const isIpadOS = () => {
    return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
}
export const isInApp = () => {
    const inapp = new InApp(navigator.userAgent || navigator.vendor || window.opera);
    const inIpadOs = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
    if (inIpadOs && navigator.userAgent.includes('Safari')) return false
    else if (inapp.isInApp || inIpadOs) return true
    else return inapp.isInApp
}

export const getMobileOperatingSystem = () => {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

export const isThisAFile = (maybeFile) => {
    return new Promise(function (resolve, reject) {
        if (maybeFile.type !== '') {
            return resolve(maybeFile);
        }
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.error && reader.error.name === 'NotFoundError') {
                return reject(reader.error.name);
            }
            resolve(maybeFile);
        };
        reader.readAsBinaryString(maybeFile);
    });
};

export const checkAttachment = (url) => {
    /** check attachment type */
    if (url) {
        const name = url.split('.');
        const ext = name[name.length - 1];
        return ext;
    }
}

export const fixed = (value, count = 0) => {
    return (Number(value) || 0).toFixed(count)
}


export const isInViewport = (element, ref) => {
    return (
        element.getBoundingClientRect().top >= 0 &&
        element.getBoundingClientRect().bottom <= (ref.innerHeight || document.documentElement.clientHeight)
    );
}

export const getName = (user) => {
    return user && (user.name || `${user ? user.firstName : '-'} ${user ? user.lastName : '-'}`)
}

export const getTimeDifference = (start, end) => {
    if (start && end) {
        start = start.split(":");
        end = end.split(":");
        let startDate = new Date(0, 0, 0, start[0], start[1], 0);
        let endDate = new Date(0, 0, 0, end[0], end[1], 0);
        let diff = endDate.getTime() - startDate.getTime();
        //if(diff < 0) diff = Math.abs(diff)
        let hours = Math.floor(diff / 1000 / 60 / 60);
        let tempHr = Math.floor(diff / 1000 / 60 / 60);
        if (hours < 0) hours += 24
        diff -= tempHr * 1000 * 60 * 60;
        let minutes = Math.floor(diff / 1000 / 60);
        if (minutes < 0) minutes = Math.abs(minutes)
        return (hours <= 9 ? "0" : "") + hours + ' Hrs ' + " " + (minutes <= 9 ? "0" : "") + minutes + ' Mins';
    }
}


export const socketHandler = (response) => {
    if (typeof response === 'string') return Decryption(response);
    else return response
}
